import { FC } from 'react';
import styles from './PunchupSpinner.module.css';

export interface PunchupSpinnerProps {
	size?: number;
}

export const PunchupSpinner: FC<PunchupSpinnerProps> = ({ size = 24 }) => (
	<span className={styles.spinner} style={{ width: size, height: size }} role="status" aria-label="Loading" />
);
